/* eslint-disable no-new */
export class Toggle {
    constructor(source) {
        this.source = source;
        this.target = this.source.dataset.target && document.getElementById(source.dataset.target);
        this.syncedChildItems = [
            ...this.getSyncChildren(this.source),
            ...this.getSyncChildren(this.target)
        ];
        this.addEventListeners();
        if (this.source.classList.contains('toggled')) this.updateState('add');
    }

    addEventListeners() {
        const action = () => {
            event.stopPropagation();
            this.updateState();
        };
        this.source.addEventListener('click', action);
        this.source.addEventListener('dynamic-click', action);
    }

    updateDOM(item, action) {
        if (item) {
            const toggleOff =
                item.classList.contains('toggled') && ['remove', 'toggle'].includes(action);
            const event = toggleOff ? 'toggledOff' : 'toggledOn';

            this.handleAriaAttributes(item, toggleOff);
            item.dispatchEvent(new CustomEvent(event, {}));
            item.classList[action]('toggled');
        }
    }

    handleAriaAttributes(item, toggleOff) {
        if (item.hasAttribute('aria-expanded')) {
            item.setAttribute('aria-expanded', toggleOff ? 'false' : 'true');
        }
        if (item.classList.contains('toggled-grow')) {
            item.setAttribute('aria-hidden', toggleOff ? 'true' : 'false');
        }
        if (item.classList.contains('toggled-hide')) {
            item.setAttribute('aria-hidden', toggleOff ? 'false' : 'true');
        }
    }

    updateState(action = 'toggle') {
        const items = [this.source, this.target, ...this.syncedChildItems];
        items.forEach((item) => this.updateDOM(item, action));
    }

    getSyncChildren(root) {
        if (!root) return [];
        let items = Array.from(root.querySelectorAll('.js-toggle-sync'));
        // Filter out items that are nested in other toggles
        const nestedToggles = Array.from(root.querySelectorAll('.js-toggle'));
        return items.filter((item) => {
            return !nestedToggles.some((toggle) => toggle.contains(item));
        });
    }
}

export default (() => {
    const toggles = Array.from(document.querySelectorAll('.js-toggle'));

    toggles.forEach((el) => {
        new Toggle(el);
    });
})();
